import { UmbrellaAppApi, UmbrellaBackendApi } from '@voomly_llc/umbrella-interapp-lib/modules';
import AppConfig from '../util/config';

const umbrellaBackendApi = new UmbrellaBackendApi({
  // env: 'local',
  env: process.env.REACT_APP_ENV === 'prod' ? 'production' : 'staging'
});

const umbrellaAppApi = UmbrellaAppApi.init({
  umbrellaBackendApi,
  logFunc: console.log
});

export const fetchSsoAppStatus = async () => {
  try {
    const { originalResponse } = await umbrellaAppApi.getStatus();

    return originalResponse;
  } catch (error) {
    // skip error handling
  }
};

export const signInWithUmbrella = async () => {
  const result = await umbrellaAppApi.authenticateViaUmbrella({
    appName: 'doodly',
    umbrellaBackendApi,
    tokenExchangeUrl: `${AppConfig.DOODLY_API_URL}/auth/umbrella-login`
  });

  if (result.status === 'success') {
    return { status: 'success', token: result.result.token };
  }

  return { status: 'error', message: result.message };
};
